      <button class="flex align-center text-primary-200"
          mat-flat-button
          type="button"
          (click)="print()">
          <app-icon name="bold-export" size="xs" class="mr-1"></app-icon>
<span>        {{ "Buttons.Export" | translate }}
</span>
      </button>
